import React from 'react'
import PropTypes from 'prop-types'

import { StyledButton } from "ui/StyledComponents/StyledButton";

import { Box } from "@mui/material";

const FloatingActionButtons = ({ onSubmit, onDiscard }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 20,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        backgroundColor: "white",
        borderRadius: 3,
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
        padding: "12px 20px",
        display: "flex",
        gap: 2,
      }}
    >
      <StyledButton
        variant="contained"
        color="primary"
        onClick={onSubmit}
      >
        Save Changes
      </StyledButton>
      <StyledButton
        variant="outlined"
        color="error"
        onClick={onDiscard}
      >
        Discard
      </StyledButton>
    </Box>
  );
};

FloatingActionButtons.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onDiscard: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default FloatingActionButtons;
